<template>
  <div class="jdProductTable">
    <v-data-table
      :headers="jdProductHeaders"
      :items="jdProductItems"
      :item-key="itemKey"
      :items-per-page="-1"
      hide-default-header
      hide-default-footer
      :no-data-text="$t('common.common_not-register')"
      class="rounded-lg"
    >
      <!-- テーブルヘッダーカスタム -->
      <template v-slot:[`header`]>
        <thead>
          <tr>
            <th colspan="1" rowspan="2" width="8%" class="firstThead">
              {{ $t(jdProductHeaders[0].text) }}
            </th>
            <th colspan="1" rowspan="2" width="11%">
              {{ $t(jdProductHeaders[1].text) }}
            </th>
            <th colspan="1" rowspan="2" width="9%">
              {{ $t(jdProductHeaders[2].text) }}
            </th>
            <th colspan="1" rowspan="2" width="18%">
              {{ $t(jdProductHeaders[3].text) }}
            </th>
            <th colspan="4" width="48%">
              {{ $t('common.common_product-register') }}
            </th>
            <th colspan="1" rowspan="2" class="lastThead" width="6%">
              {{ $t(jdProductHeaders[8].text) }}
            </th>
          </tr>
          <tr>
            <th colspan="1" width="20%">
              {{ $t(jdProductHeaders[4].text) }}
            </th>
            <th colspan="1" width="13%">
              {{ $t(jdProductHeaders[5].text) }}
            </th>
            <th colspan="1" width="7%">
              {{ $t(jdProductHeaders[6].text) }}
            </th>
            <th colspan="1" width="8%">
              {{ $t(jdProductHeaders[7].text) }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="(item, trIndex) in getFormatRow(items)"
            :key="`group-${trIndex}`"
            v-bind:class="{
              rowColor: item.jdProductIndex % 2 !== 0
            }"
          >
            <template v-for="(header, parentIndex) in jdProductHeaders">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none',
                  firstTd: item.isLastRow && 0 === parentIndex,
                  lastTd:
                    item.isLastRow &&
                    jdProductHeaders.length - 1 === parentIndex
                }"
                :key="parentIndex"
                v-if="
                  (item.isFirst && !('rowspan' in header)) || header.rowspan
                "
                :rowspan="item.relatedProductLength"
                class="parentIndexTd"
              >
                <slot :name="header.value" v-bind:item="item.jdProductList">
                  {{ getDefaultValue(item.jdProductList, header) }}
                </slot>
              </td>
              <!-- 登録商品の項目表示 -->
              <td
                v-if="'rowspan' in header && !header.rowspan"
                :key="parentIndex"
              >
                <div v-if="isName(header, 'jdRelatedProductName')">
                  <div class="my-2" v-if="item.relatedProductInfo.product">
                    {{ item.relatedProductInfo.product.nameJp }} <br />
                    {{ item.relatedProductInfo.product.nameCn }} <br />
                  </div>
                  <div v-else class="my-2">{{ '-' }}</div>
                </div>
                <div
                  class="text-center"
                  v-if="isName(header, 'jdRelatedProductSupplier')"
                >
                  <div class="my-2" v-if="item.relatedProductInfo.product">
                    {{
                      getSupplierName(
                        item.relatedProductInfo.product.supplierId
                      )
                    }}
                  </div>
                  <div v-else class="my-2">-</div>
                </div>
                <div
                  class="text-center"
                  v-if="isName(header, 'jdRelatedProductQuantity')"
                >
                  {{ item.relatedProductInfo.quantity || '-' }}
                </div>
                <div
                  class="text-center"
                  v-if="isName(header, 'jdRelatedProductPrice')"
                >
                  <div class="my-2" v-if="item.relatedProductInfo.price">
                    {{
                      formatPrice(
                        Number(item.relatedProductInfo.price)
                      ).toLocaleString() + getCurrencyUnitName(item.platformId)
                    }}
                  </div>
                  <div v-else class="my-2">-</div>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { commonUtil, platformUtil, currencyUtil } from '@/util'
export default {
  props: {
    headers: [],
    jdProductItems: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String
  },
  data: () => ({
    itemsDetail: [],
    jdProductHeaders: [],
    supplierList: []
  }),
  async created() {
    this.createHeaders()
    await this.getPlatformListFromApi()
    await this.getSupplierList()
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    ...mapActions('Platform', ['getPlatformListFromApi']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    async getSupplierList() {
      await this.getSuppliersFromApi()
      this.supplierList = this.getSuppliersFromState()
    },
    getSupplierName(supplierId) {
      const supplier = this.supplierList.find(
        (element) => element.supplierId === supplierId
      )
      return supplier ? supplier.name : ''
    },
    getCurrencyUnitName(platformId) {
      const platform = platformUtil.getPlatformById(platformId)
      if (!platform) return ''
      const currency = currencyUtil.findCurrencyNameById(
        platformUtil.getCurrencyIdByPlatformCurrencyId(
          platform.platformCountryId
        )
      )
      return currency ? currency.unitName : ''
    },
    getFormatRow(jdProductList) {
      return jdProductList.reduce((result, current, currentIndex) => {
        const isLastRow = jdProductList.length - 1 === currentIndex

        if (!current.exProductRelatedProductList.length) {
          result.push({
            jdProductIndex: currentIndex,
            isLastRow: isLastRow,
            jdProductId: current.jdProductId,
            platformId: current.platformId,
            isFirst: true,
            relatedProductIndex: -1,
            relatedProductLength: 1,
            relatedProductInfo: {},
            jdProductList: current
          })
        } else {
          current.exProductRelatedProductList.map((ele, index) => {
            result.push({
              jdProductIndex: currentIndex,
              isLastRow: isLastRow,
              jdProductId: current.jdProductId,
              platformId: current.platformId,
              isFirst: index === 0,
              relatedProductIndex: index,
              relatedProductLength: current.exProductRelatedProductList.length,
              relatedProductInfo: ele,
              jdProductList: current
            })
          })
        }

        return result
      }, [])
    },

    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          align: 'align' in header ? header.align : ''
        }
      })
      this.jdProductHeaders = this.headers
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val : '-'
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    }
  }
}
</script>
<style lang="scss" scoped>
.jdProductTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table thead tr:last-child th {
    border-top: 0;
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    border-collapse: collapse;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
    border-spacing: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table .parentIndexTd:last-child {
    border-right: 1px solid #d8d8d8 !important;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .firstThead {
    border-radius: 10px 0 0 0;
  }
  .lastThead {
    border-radius: 0 10px 0 0;
  }

  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .rowColor {
    background-color: rgba(213, 213, 213, 0.1);
  }
  .firstTd {
    border-radius: 0 0 0 10px;
  }
  .lastTd {
    border-radius: 0 0 10px 0;
  }
}
</style>
